export default __webpack_public_path__ + "static/media/gloves_of_ferine_anger.15ba4e8a.jpg";